import { Navigate, Outlet } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuth } from '@/contexts/AuthContext'
import NoPermissionsPage from '@/pages/NoPermissionsPage'

const PrivateRoute = () => {
  const { user, loading, permissions } = useAuth()

  if (loading) {
    return <Spin fullscreen size="large" tip="Caricamento..." />
  }

  if (!user) return <Navigate to="/" replace />

  // Admin (ruolo_id=1) bypassa sempre il check — tutti gli altri devono avere almeno un permesso
  if (user.ruolo_id !== 1 && permissions.length === 0) {
    return <NoPermissionsPage />
  }

  return <Outlet />
}

export default PrivateRoute
